import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Onions</title>
                    <meta name="description" content="At A&W, our onion growers produce some of the highest quality and most flavourful onions on the market." />
                </Helmet>
            :
                <Helmet>
                    <title>Nos oignons</title>
                    <meta name="description" content="Chez A&W, nos cultivateurs d’oignons produisent des oignons parmi les plus savoureux et ceux de meilleure qualité sur le marché." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;